import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=2a222488&scoped=true&"
import script from "./UserHeader.vue?vue&type=script&lang=js&"
export * from "./UserHeader.vue?vue&type=script&lang=js&"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=2a222488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a222488",
  null
  
)

export default component.exports